import { render, staticRenderFns } from "./ClassSelectorButton.vue?vue&type=template&id=67389454&scoped=true"
import script from "./ClassSelectorButton.vue?vue&type=script&lang=js"
export * from "./ClassSelectorButton.vue?vue&type=script&lang=js"
import style0 from "./ClassSelectorButton.vue?vue&type=style&index=0&id=67389454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67389454",
  null
  
)

export default component.exports